<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-4/5 max-h-[90%] rounded-lg primary-purple-light-2-background p-[30px] overflow-y-auto" (click)="onModalClick($event)">
        <div class="flex items-center justify-between">
            <div>
                <p class="font-bold text-lg neutrals-grey-06-text primary-purple-text">{{
                    literalService.get(selectedFavouriteType === FavouriteType.PUNTUAL ? 'favourites.title' : 'favourites.titleRecurrent', true) }}</p>
                @if (favourites.value.length) {
                    <p class="font-normal text-base neutrals-grey-06-text pb-2 primary-purple-text">{{
                        literalService.get('favourites.select', true) }}</p>
                }
            </div>
            <div class="flex items-center">
                <app-custom-toggle
                    class="mr-12"
                    [id]="'favourite-routes-toggle'"
                    [selectedValue]="selectedFavouriteType"
                    [firstValue]="FavouriteType.PUNTUAL"
                    [secondValue]="FavouriteType.RECURRENT"
                    [firstImage]="images.favourites.calendarFavourite"
                    [secondImage]="images.favourites.recurrent"
                    [firstDescription]="literalService.get('favourites.puntual', true)"
                    [secondDescription]="literalService.get('favourites.recurrent', true)"
                    [small]="true"
                    [color]="'secondary'"
                    (action)="changeSelectedFavouriteType()"
                />
                <button (click)="closeModal()" type="button"
                    class="absolute right-8 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                   >
                    <img [src]="images.close" class="h-6 w-6" />
                </button>
            </div>
        </div>
        <section class="mt-6">
            @if (selectedFavouriteType === FavouriteType.PUNTUAL) {
                <form #form novalidate>
                    @for (favourite of favourites.value; track $index) {
                        <section
                            class="grid grid-cols-11 cursor-pointer w-full pt-2 pb-2 border-2 neutrals-grey-02-border mb-2 items-center justify-start bg-white rounded"
                            (click)="selectFavouriteRoute(favourite)"
                            [ngClass]="{'primary-purple-light-border': this.selectedFavourite === favourite}">
                            <div class="flex h-full items-center justify-center text-center col-span-2 border-r gap-2">
                                <label class="text-lg font-semibold cursor-pointer">{{ favourite.name }}</label>
                                @if (favourite.type === FavouriteRouteType.POSITION) {
                                    <span class="text-xs font-semibold px-1.5 py-0.5 rounded-full primary-purple-background text-white">D2D</span>
                                }
                            </div>
                            <div class="flex h-full items-center justify-center text-center col-span-3 border-r">
                                <label class="text-lg font-semibold cursor-pointer">{{ favourite.town?.name }}</label>
                            </div>
                            <div class="flex h-full items-center justify-center col-span-1 border-r">
                                <label class="text-lg font-semibold cursor-pointer">{{ favourite.time?.split(':')![0] + ':' +
                                    favourite.time?.split(':')![1] }}</label>
                            </div>
                            <div class="h-full col-span-4 border-r ml-8 pr-8 flex flex-col justify-center">
                                <div class="flex items-center">
                                    <img [src]="images.origin" alt="origin" class="w-4 h-4 mr-1" />
                                    <label [id]="`origin-${$index}`" class="text-lg font-semibold cursor-pointer truncate leading-tight" [visibleTooltip]="utilsService.visibleTooltip(`origin-${$index}`)" [tooltip]="favourite.inStop?.name || ''">{{ favourite.inStop?.name }}</label>
                                </div>
                                <div class="flex items-center">
                                    <img [src]="images.destination" alt="destination" class="w-4 h-4 mr-1" />
                                    <label [id]="`destination-${$index}`" class="text-lg font-semibold cursor-pointer truncate leading-tight" [visibleTooltip]="utilsService.visibleTooltip(`destination-${$index}`)" [tooltip]="favourite.outStop?.name || ''">{{ favourite.outStop?.name }}</label>
                                </div>
                            </div>
                            <div class="h-full items-center col-span-1 ml-4 flex flex-col justify-center">
                                <div class="flex items-center">
                                    <img [src]="images.pax" alt="destination" class="w-4 h-4 mr-1" />
                                    <label class="text-lg font-semibold cursor-pointer leading-tight">{{ passengers(favourite) }}</label>
                                </div>
                                <div class="flex items-center">
                                    <img [src]="images.prm" alt="destination" class="w-4 h-4 mr-1" />
                                    <label class="text-lg font-semibold cursor-pointer leading-tight">{{ prmPassengers(favourite) }}</label>
                                </div>
                            </div>
                        </section>
                    } @empty {
                        <div class="flex items-center justify-center">
                            <img [src]="images.favourites.noOptions" class="h-96 w-96" alt="favouriteNoOptions" />
                        </div>
                        <div class="flex items-center justify-center -mt-5 mb-5">
                            <label class="font-bold text-lg text-center uppercase neutrals-grey-04-text">{{
                                literalService.get('favourites.noFavourites') }}</label>
                        </div>
                    }
                </form>
            }
            @if (selectedFavouriteType === FavouriteType.RECURRENT) {
                <form #form novalidate>
                    @for (recurrent of recurrents.value; track $index) {
                        <section
                            class="grid grid-cols-11 cursor-pointer w-full pt-2 pb-2 border-2 neutrals-grey-02-border mb-2 items-center justify-start bg-white rounded"
                            (click)="selectRecurrent(recurrent)"
                            [ngClass]="{'primary-purple-light-border': this.selectedRecurrent === recurrent}">
                            <div class="flex h-full items-center justify-center text-center col-span-1 border-r gap-1">
                                <label class="text-lg/5 font-semibold cursor-pointer truncate">{{ recurrent.name }}</label>
                                @if (recurrent.favorite.type === FavouriteRouteType.POSITION) {
                                    <span class="text-xs font-semibold px-1.5 py-0.5 rounded-full primary-purple-background text-white">D2D</span>
                                }
                            </div>
                            <div class="flex h-full flex-wrap items-center justify-center text-center col-span-1 border-r">
                                <label class="text-lg font-semibold cursor-pointer truncate">{{ recurrent.startDate | date: 'dd/MM/yyyy' }}</label>
                                <label class="text-lg font-semibold cursor-pointer truncate">{{ recurrent.endDate | date: 'dd/MM/yyyy' }}</label>
                            </div>
                            <div class="h-full items-center justify-center col-span-2 border-r line-clamp-2 text-center">
                                <label class="text-lg font-semibold cursor-pointer">{{ literalService.get('bookings.repeatEvery.'+recurrent.repeatEvery, true) }}</label>
                                <div [id]="`days-${$index}`" [visibleTooltip]="utilsService.visibleTooltip(`days-${$index}`)" [tooltip]="getDays(recurrent.daysOfWeek!) || ''">
                                    <label class="text-lg font-semibold cursor-pointer">{{ getDays(recurrent.daysOfWeek!) }}</label>
                                </div>
                            </div>
                            <div class="flex h-full items-center justify-center col-span-1 border-r">
                                <label class="text-lg font-semibold cursor-pointer">{{ recurrent.bookingTime }}</label>
                            </div>
                            <div class="flex h-full items-center justify-center col-span-2 border-r px-2">
                                <label class="text-lg font-semibold cursor-pointer truncate">{{ recurrent.favorite.town!.name }}</label>
                            </div>
                            <div class="h-full col-span-3 border-r ml-4 pr-4 flex flex-col justify-center">
                                <div class="flex items-center">
                                    <img [src]="images.origin" alt="origin" class="w-4 h-4 mr-1" />
                                    <label [id]="`origin-${$index}`" class="text-lg font-semibold cursor-pointer truncate leading-tight" [visibleTooltip]="utilsService.visibleTooltip(`origin-${$index}`)" [tooltip]="recurrent.favorite.inStop?.name || ''">{{ recurrent.favorite.inStop?.name }}</label>
                                </div>
                                <div class="flex items-center">
                                    <img [src]="images.destination" alt="destination" class="w-4 h-4 mr-1" />
                                    <label [id]="`destination-${$index}`" class="text-lg font-semibold cursor-pointer truncate leading-tight" [visibleTooltip]="utilsService.visibleTooltip(`destination-${$index}`)" [tooltip]="recurrent.favorite.outStop?.name || ''">{{ recurrent.favorite.outStop?.name }}</label>
                                </div>
                            </div>
                            <div class="h-full items-center col-span-1 flex flex-col justify-center">
                                <div class="flex items-center">
                                    <img [src]="images.pax" alt="destination" class="w-4 h-4 mr-1" />
                                    <label class="text-lg font-semibold cursor-pointer leading-tight">{{ recurrent.favorite.passengers }}</label>
                                </div>
                                <div class="flex items-center">
                                    <img [src]="images.prm" alt="destination" class="w-4 h-4 mr-1" />
                                    <label class="text-lg font-semibold cursor-pointer leading-tight">{{ recurrent.favorite.prmPassengers }}</label>
                                </div>
                            </div>
                        </section>
                    } @empty {
                        <div class="flex items-center justify-center">
                            <img [src]="images.favourites.noOptions" class="h-96 w-96" alt="favouriteNoOptions" />
                        </div>
                        <div class="flex items-center justify-center -mt-5 mb-5">
                            <label class="font-bold text-lg text-center uppercase neutrals-grey-04-text">{{
                                literalService.get('favourites.noRecurrents') }}</label>
                        </div>
                    }
                </form>
            }
        </section>
        <section class="relative flex flex-col pt-6">
            @if (favourites.value.length > 0) {
                <app-pagination [pagination]="favourites.pagination" [right]="false" (changePage)="onChangePagination($event)" />
                <div class="flex mt-[74px] justify-between">
                    @if (selectedFavouriteType === FavouriteType.PUNTUAL) {
                        <div>
                            <input (click)="onNewFavourite()" type="button"
                                class="secondary gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase cursor-pointer"
                                [value]="literalService.get('favourites.newFavourite', true)"
                                [disabled]="selectedFavourite" />
                        </div>
                        <div class="flex justify-end w-full">
                            <input (click)="onDelete()" type="button"
                                class="secondary gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase"
                                [ngClass]="{'cursor-pointer': selectedFavourite}"
                                [value]="literalService.get('bookings.actions.viewFavourite.delete.title', true)"
                                [disabled]="!selectedFavourite" />
                            <input (click)="onEdit()" type="button"
                                class="secondary gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase ml-2"
                                [ngClass]="{'cursor-pointer': selectedFavourite}"
                                [value]="literalService.get('bookings.actions.viewFavourite.edit.title', true)"
                                [disabled]="!selectedFavourite" />
                            <input (click)="newBooking()" type="button"
                                class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase ml-2"
                                [ngClass]="{'cursor-pointer': selectedFavourite}"
                                [value]="isFromUser ? literalService.get('bookings.actions.viewFavourite.newBooking', true) : literalService.get('bookings.actions.viewFavourite.select', true)"
                                [disabled]="!selectedFavourite" />
                        </div>
                    }
                    @if (selectedFavouriteType === FavouriteType.RECURRENT) {
                        <div class="flex justify-end w-full">
                            <input (click)="onDeleteRecurrent()" type="button"
                                class="secondary gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase"
                                [ngClass]="{'cursor-pointer': selectedRecurrent}"
                                [value]="literalService.get('bookings.actions.viewRecurrent.delete.title', true)"
                                [disabled]="!selectedRecurrent" />
                            <input (click)="onEditRecurrent()" type="button"
                                class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase ml-2"
                                [ngClass]="{'cursor-pointer': selectedRecurrent}"
                                [value]="literalService.get('bookings.actions.viewRecurrent.edit.title', true)"
                                [disabled]="!selectedRecurrent" />
                        </div>
                    }
                </div>
            }
            @else {
                <div class="flex mt-6 justify-end">
                    <input (click)="onNewFavourite()" type="button"
                        class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-40 uppercase cursor-pointer"
                        [value]="literalService.get('favourites.newFavourite', true)"/>
                </div>
            }
        </section>
    </div>
</div>